import { WorkingConditionSettingVO } from '@/service-proxies/app-v2/workStation.service-proxies'

interface RemoteArg {
  id: string
  show?: boolean
  title?: string
  group?: RemoteArg[]
}

interface LocalArg extends Partial<WorkingConditionSettingVO> {
  id: string
  show?: boolean
  title?: string
  group?: LocalArg[]
}
type LocalArgsList = LocalArg[][]
type RemoteArgsList = RemoteArg[][]

export function transformRemoteToLocal(
  remoteArgsList: RemoteArgsList,
  originalArgs: WorkingConditionSettingVO[]
): LocalArgsList {
  if (!remoteArgsList) return [[], [], []]
  return remoteArgsList.map(remoteArgs => {
    const temp = []
    for (let remoteArg of remoteArgs) {
      if (remoteArg.group) {
        console.log(remoteArg)
        const newGroup = []
        for (let groupArg of remoteArg.group) {
          const foundArg = originalArgs.find(
            originalArg => originalArg.id === groupArg.id || originalArg.id === groupArg.id.slice(0, -4)
          )
          if (foundArg) {
            if (foundArg.bizType === 3) {
              if (groupArg.id.includes('code')) newGroup.push({ ...foundArg, ...groupArg, paramDesc: '报警代码' })
              if (groupArg.id.includes('info')) newGroup.push({ ...foundArg, ...groupArg, paramDesc: '报警信息' })
              if (groupArg.id.includes('time')) newGroup.push({ ...foundArg, ...groupArg, paramDesc: '报警时间' })
            } else {
              newGroup.push({ ...groupArg, ...foundArg })
            }
          }
        }
        console.log(newGroup)
        temp.push({ ...remoteArg, group: newGroup })
        continue
      }
      const foundArg = originalArgs.find(
        originalArg => originalArg.id === remoteArg.id || originalArg.id === remoteArg.id.slice(0, -4)
      )
      if (foundArg) {
        if (foundArg.bizType === 3) {
          if (remoteArg.id.includes('code')) temp.push({ ...foundArg, ...remoteArg, paramDesc: '报警代码' })
          if (remoteArg.id.includes('info')) temp.push({ ...foundArg, ...remoteArg, paramDesc: '报警信息' })
          if (remoteArg.id.includes('time')) temp.push({ ...foundArg, ...remoteArg, paramDesc: '报警时间' })
        } else {
          temp.push({ ...remoteArg, ...foundArg })
        }
      }
    }
    return temp
  })
}

export function transformLocalToRemote(localArgsList: LocalArgsList): RemoteArgsList {
  return localArgsList.map(localArgs =>
    localArgs.map(localArg =>
      localArg.group
        ? {
            id: localArg.id,
            title: localArg.title,
            group: localArg.group.map(groupArg => ({ id: groupArg.id, show: groupArg.show })),
          }
        : {
            id: localArg.id,
            show: localArg.show,
            paramDesc: localArg.paramDesc,
          }
    )
  )
}

export function transformArgToKey(localArgsList: LocalArgsList, tenantId: string) {
  return localArgsList
    .flatMap(args => args.flatMap(arg => (arg.group ? arg.group : arg)).filter(arg => arg.bizType === 1))
    .map(arg => `${tenantId}/${arg.iotId}/${arg.iotAppId}/${arg.iotAppParamDesc}`)
}

export function generateLocalArgsList(remoteArgsList: RemoteArgsList, originalArgs: WorkingConditionSettingVO[]) {
  const temp = transformRemoteToLocal(remoteArgsList, originalArgs)
  // console.log(JSON.stringify(temp, undefined, 4))
  const allIds = remoteArgsList
    .flat()
    .flatMap(item => (item.group ? item.group : item))
    .map(item => item.id)
  // console.log(JSON.stringify(allIds, undefined, 4))
  const flag = !!allIds.find(id => id.includes('code'))
  originalArgs
    .filter(oArg => !allIds.includes(oArg.id))
    .forEach((param, index) => {
      // console.log(JSON.stringify(param, undefined, 4))
      if (param.bizType === 3) {
        if (flag) {
          return
        }
        temp[index % 3].push({ ...param, show: true, paramDesc: '报警代码', id: param.id + 'code' })
        temp[index % 3].push({ ...param, show: true, paramDesc: '报警信息', id: param.id + 'info' })
        temp[index % 3].push({ ...param, show: true, paramDesc: '报警时间', id: param.id + 'time' })
      } else {
        temp[index % 3].push({ ...param, show: true })
      }
    })
  // debugger
  // console.log(JSON.stringify(temp, undefined, 4))
  return temp
}
